import { ErrorHandler, Injectable } from "@angular/core";
import posthog from "posthog-js";

@Injectable()
export class PostHogErrorHandler implements ErrorHandler {
  handleError(error: any): void {
    posthog.captureException(error, {
      source: "AngularErrorHandler"
    });
    throw error; // lets Angular still show the error in console
  }
}
